import { render } from "./pinglun.vue?vue&type=template&id=7f96dddc"
import script from "./pinglun.vue?vue&type=script&lang=js"
export * from "./pinglun.vue?vue&type=script&lang=js"

import "./pinglun.vue?vue&type=style&index=0&id=7f96dddc&lang=less"
import "./pinglun.vue?vue&type=style&index=1&id=7f96dddc&lang=less"

import exportComponent from "F:\\project\\zifeiluntang\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__